import { useQuery } from "react-query";
import * as summariesService from "api/services/summaryService";

/**
 * Store server's state of project results
 *
 * @param {summariesService.SummaryPayload} payload The summary request payload of the project results being fetched
 *
 * @returns The query object returned by the useQuery hook
 */
export const useProjectQuestionnairesData = (payload) =>
  useQuery(
    ["projectQuestionnaires", payload],
    () => summariesService.getProjectQuestionnaires(payload),
    {
      select: ({ data }) => data,
      enabled: !!Object.keys(payload)?.length,
      refetchOnWindowFocus: false,
    }
  );
